import React, {useEffect, useRef} from "react";
import "./about.css";
import "./solutions.css";
import gsap from "gsap";
import blackLogo from "./blackLogo.jpg";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


function About(){

const about = useRef(null);
const wrapper = useRef(null);
const weAre = useRef(null);
const img = useRef(null);
const text = useRef(null);
const solutionsdiv= useRef(null);
const soloHead = useRef(null);


useEffect(()=>{
    const ctx = gsap.context(()=>{
       let tl = gsap.timeline({
            scrollTrigger: {
              trigger: wrapper.current,
              pin: true,
              start: "top top",
              end: "+=500%",
              scrub: true,
              preventOverlaps: true,
              fastScrollEnd:true
            }
          })
          tl.to(img.current, {
            opacity:1,
          },"+=0.4");
            tl.fromTo(weAre.current,
            { maskPosition: "-1200px 0px", opacity: 0 },
            {
              maskPosition: "0px 0px",
              ease: "power1.ease",
              opacity: 1,
            }, "+=0.4")
            tl.fromTo(text.current, 
            {opacity: 0.2},
            {
            ease: "power1.ease", opacity: 1,
            },"+=0.4")
            tl.to(img.current, {
              ease: "power1.ease",
              yPercent: -190,
              scale: 0,
            },"+=0.4");
        });
        return () => ctx.revert();
      }, []);

      useEffect(()=>{
        const ctx = gsap.context(()=>{
            const tl = gsap.timeline({
                scrollTrigger: {
                  trigger: wrapper.current,
                  pin: false,
                  start: "100vh top",
                  end:"100vh",
                  scrub:false,
                }
              })
              tl.to(
                soloHead.current,
                {ease:'power1.ease',scale:2.2},"+=0.4")
              tl.to(
                    soloHead.current,
                    {yPercent:200, ease: "power1.ease" },"+=0.3")
          });
              return () => ctx.revert();
          }, []);

return(
  <>
  <div className="wrapper" ref={wrapper} style={{height: "200vh", width: "100%"}}>
    <div className="About" ref={about}>
     <h1 className="Hello" ref={weAre}>Who We Are</h1>
       <p className="text" ref={text}>
       The company offers solutions for engineering proiects in the marine and navy industries. <br></br>
            From concept design to detail design, we used all the well-known<br></br>
            software to simulate and analyze the engineering design following all
            necessary written reports.<br></br>
            We can lead a project by taking all the necessary steps and risk mitigation<br></br>
            at any project phase.<br></br>
            Some of the services that we offer:<br></br>
            • Ship stability calculations<br></br>
            • Ship Heat balance calculations<br></br>
            • Ship hull and machinery survey<br></br>
            • Auxiliary system design<br></br>
            • Power and performance design and evaluation<br></br>
            • Technical written and engineering reports<br></br>
            • Integration of a system regarding seating and interfacing<br></br>
            • Software Solutions<br></br>

       </p>
     <img className="img" alt="Idan-Logo" src={blackLogo} ref={img} />
    </div>
    <div className="solutions" ref={solutionsdiv}>
        <h1 ref={soloHead}>Our Solutions</h1>
    </div>
  </div>
    </>
)
}

export default About;
